import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestangularModule, Restangular } from "ngx-restangular";
import {API_URL } from '../config';

@Injectable()
export class EmployeeService {
  private baseUrl = "/api/v1"; // Replace with your Laravel API URL
  private baseUrlNew = API_URL+"/api/v1";  // "https://qhsebe.ilooopsqhse.com/api/v1";
  
  constructor(private http: HttpClient, private restangular: Restangular,) {}
  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  // getEmployeesByDesignationCategoryID(
  //   designationCategoryID: number
  // ): Observable<any> {
  //   const headers = this.getHeaders();
  //   let data = "";
  //   return this.http.post(`${this.baseUrl}/getAll`, data, {
  //     headers,
  //   });
  // }




  // getEmployeesByDesignationCategoryID(designationCategoryID: number): Observable<any> {
  //   const headers = this.getHeaders();
  //   return this.http.post(`${this.baseUrlNew}/getAllDesignationCategoryID`, { id: designationCategoryID }, {
  //     headers,
  //   });
  // }

  getEmployeesByDesignationCategoryID(filter: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.baseUrlNew}/getAllDesignationCategoryID`, filter, {
      headers,
    });
  }




  public getAllDesignationCategoryIDTable() {
    return this.restangular.one("getAllDesignationCategoryIDTable");
  }


  getFilteredEmployees() {
    return this.restangular.all("getFilteredEmployees");
  }

  
  getAllEmployeesCreateAsses(filter: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.baseUrlNew}/getAllEmployeesCreateAsses`, filter, {
      headers,
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/employee.service.ts